import React, { useState } from "react";
////TABLA
import { useTable, useSortBy, useFilters } from "react-table";
import { useExportData } from "react-table-plugins";
import Papa from "papaparse";
// import XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import makeData from "./makeData";
//TABLA
// Pagination
import TablePagination from "@mui/material/TablePagination";

// GRID
import Grid from "@mui/material/Grid";

// DATEPICKER
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// DATEPICKER

// SELECT
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";
// SELECT
import styled from "styled-components";

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length;

  // console.log(filterValue);
  // console.log(preFilteredRows);
  // console.log(setFilter);
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        // console.log(e.target.value, 'e.target.value' );
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Buscar ${count} registros...`}
    />
  );
}

const defaultColumn = {
  Filter: DefaultColumnFilter,
};

function getExportFileBlob({ columns, data, fileType, fileName }) {
  if (fileType === "csv") {
    // CSV example
    const headerNames = columns.map((col) => col.exportValue);
    const csvString = Papa.unparse({ fields: headerNames, data });
    return new Blob([csvString], { type: "text/csv" });
  } else if (fileType === "xlsx") {
    // XLSX example

    // const header = columns.map((c) => c.exportValue);
    // const compatibleData = data.map((row) => {
    //   const obj = {};
    //   header.forEach((col, index) => {
    //     obj[col] = row[index];
    //   });
    //   return obj;
    // });

    // let wb = XLSX.utils.book_new();
    // let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
    //   header,
    // });
    // XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
    // XLSX.writeFile(wb, `${fileName}.xlsx`);

    // Returning false as downloading of file is already taken care of
    return false;
  }
  //PDF example
  if (fileType === "pdf") {
    const headerNames = columns.map((column) => column.exportValue);
    const doc = new JsPDF();
    doc.autoTable({
      head: [headerNames],
      body: data,
      margin: { top: 20 },
      styles: {
        minCellHeight: 9,
        halign: "left",
        valign: "center",
        fontSize: 11,
      },
    });
    doc.save(`${fileName}.pdf`);

    return false;
  }

  // Other formats goes here
  return false;
}

function Table({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    exportData,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      getExportFileBlob,
    },
    useFilters,
    useSortBy,
    useExportData
  );

  //PAGINATION
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(10);
  };
  const [page, setPage] = React.useState(0); // originalmente 2
  const [rowsPerPage, setRowsPerPage] = React.useState(10); // originalmente 10
  //PAGINATION

  return (
    <>
      <div
        style={{
          margin: "auto",
          // display: 'inline-block',
          margin: "auto",
          textAlign: "center",
        }}
      >
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("csv", true);
          }}
        >
          Todo CSV
        </button>
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("csv", false);
          }}
        >
          CSV
        </button>
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("xlsx", true);
          }}
        >
          Todo xlsx
        </button>
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("xlsx", false);
          }}
        >
          xlsx
        </button>
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("pdf", true);
          }}
        >
          Todo PDF
        </button>{" "}
        <button
          className="tableButton"
          style={{
            marginRight: "5px",
          }}
          onClick={() => {
            exportData("pdf", false);
          }}
        >
          PDF
        </button>
        <button
          className="greenButton"
          style={{
            marginLeft: "200px",
          }}
          onClick={() => {}}
        >
          Crear Nuevi
        </button>
      </div>
      <hr
        style={{
          width: "65%",
          border: "1px solid black",
        }}
      ></hr>
      <div
        style={{
          overflowX: "auto",
        }}
      >
        <div className="mostrando">Mostrando {rows.length} resultados</div>
        <table {...getTableProps()} className="generalTableStyle">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  // Add the sorting props to control sorting. For this example
                  // we can add them into the header props
                  <th {...column.getHeaderProps()}>
                    {/* {console.log(column)} */}
                    <span {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                    </span>
                    <div>
                      {column.canFilter ? column.render("Filter") : null}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                  <td className="tableClass">
                    <button
                      className="greenButton"
                      style={{ margin: "5px" }}
                      onClick={() => {}}
                    >
                      Ver
                    </button>
                    <button
                      className="greenButton"
                      style={{ margin: "5px" }}
                      onClick={() => {}}
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <br />
        <TablePagination
          component="div"
          count={10}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          style={{
            width: "80%",
            overflowX: "hidden" /* Hide vertical scrollbar */,
            overflowY: "hidden" /* Hide horizontal scrollbar */,
            textAlign: "right",
          }}
        />
      </div>
    </>
  );
}

const InformeLlamadas = () => {

  const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border-radius: 0px;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }

  // DATEPICKER

  .css-i4bv87-MuiSvgIcon-"root" {
    position: absolute !important;
    top: -5px !important;
    left: -14px !important;
    font-size: 27px !important;
    color: black !important;
`;

  //TABLA
  const columnsTable1 = React.useMemo(
    () => [
      {
        Header: `Llamadas por Dia`,
        columns: [
          {
            Header: "Día",
            accessor: "díaPorDia",
          },
          {
            Header: "Fecha",
            accessor: "fechaPorDia",
          },
          {
            Header: "Recibidas",
            accessor: "recibidasPorDia",
          },
          {
            Header: "Atendidas",
            accessor: "atendidasPorDia",
          },
          {
            Header: "No Atendidas",
            accessor: "noAtendidasPorDia",
          },
          {
            Header: "Sin respuesta",
            accessor: "SinRespuestaPorDia",
          },
          {
            Header: "Canceladas",
            accessor: "CanceladasPorDia",
          },
          {
            Header: "Otros",
            accessor: "OtrosPorDia",
          },
        ],
      },
    ],
    []
  );

  const columnsTable2 = React.useMemo(
    () => [
      {
        Header: `Llamadas por Destino`,
        columns: [
          {
            Header: "Destino",
            accessor: "destinoPorDestino",
          },
          {
            Header: "Recibidas",
            accessor: "recibidasPorDestino",
          },
          {
            Header: "Atendidas",
            accessor: "atendidasPorDestino",
          },
          {
            Header: "No Atendidas",
            accessor: "noAtendidasPorDestino",
          },
          {
            Header: "Sin respuesta",
            accessor: "sinRespuestaPorDestino",
          },
          {
            Header: "Canceladas",
            accessor: "canceladasPorDestino",
          },
          {
            Header: "Otros",
            accessor: "otrosPorDestino",
          },
        ],
      },
    ],
    []
  );

  const columnsTable3 = React.useMemo(
    () => [
      {
        Header: `Llamadas`,
        columns: [
          {
            Header: "Asociación",
            accessor: "DiaLLa",
          },
          {
            Header: "Zona",
            accessor: "FechaLLa",
          },
          {
            Header: "Provincia",
            accessor: "OrigenLLa",
          },
          {
            Header: "Cantidad",
            accessor: "DestinoLLa",
          },
          {
            Header: "Asociación",
            accessor: "EstadoLLa",
          },
          {
            Header: "Zona",
            accessor: "Duración_LlamadaLLa",
          },
          {
            Header: "Provincia",
            accessor: "Duración_IVRLLa",
          },
          {
            Header: "Cantidad",
            accessor: "Duración_ConvLLa",
          },
          {
            Header: "Provincia",
            accessor: "Nodo_TransfLLa",
          },
          {
            Header: "Cantidad",
            accessor: "GrabaciónLLa",
          },
        ],
      },
    ],
    []
  );

  const data = React.useMemo(() => makeData(10), []);
  //TABLA

  //SELECT
  const handleChange = (event) => {
    // console.log(event, 'event');
    // console.log(event.target, 'event.target');
    // console.log(event.target.value, 'event.target.value');
    setName(event.target.value);
  };
  const [name, setName] = React.useState("");
  // SELECT

  // DATEPICKER
  const [dateInformePorUsuarioDesde, setDateInformePorUsuarioDesde] =
    React.useState(new Date());
  const [dateInformePorUsuarioHasta, setDateInformePorUsuarioHasta] =
    React.useState(new Date());
  // DATEPICKER

  return (
    <div className={"fatherContainer"}>
      <div className="viewHead">
        <h2 className={"title"}>Informes</h2>
        <div className={"paragraph"}>
          <a href="/" style={{ textDecoration: "none", color: "black " }}>
            Inicio
          </a>{" "}
          / <b> Informe Llamadas </b>
        </div>
      </div>
      <div className={"mainContainer"}>
        <div className={"titleSub"}>Seleccionar rango por fechas</div>
        <Styles>
          <FormControl sx={{ m: 0, minWidth: 120 }} style={{ margin: "20px" }}>
            <InputLabel id="demo-simple-select-autowidth-label">
              Empresa
            </InputLabel>
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={name}
              onChange={handleChange}
              autoWidth
              label="Nombre"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value={20}>Fidelitis</MenuItem>
              <MenuItem value={21}>Peritos Legales</MenuItem>
            </Select>
          </FormControl>
          <LocalizationProvider>
            <DateTimePicker
              renderInput={(props) => <TextField {...props} />}
              label="Desde"
              value={dateInformePorUsuarioDesde}
              onChange={(newValue) => {
                setDateInformePorUsuarioDesde(newValue);
              }}
            />
            <DateTimePicker
              renderInput={(props) => <TextField {...props} />}
              label="Hasta"
              value={dateInformePorUsuarioHasta}
              onChange={(newValue) => {
                setDateInformePorUsuarioHasta(newValue);
              }}
            />
          </LocalizationProvider>
        </Styles>
        <div className={"titleSub"}>
          Expedientes asignados, actualizados y solicitudes
        </div>
        <Grid container spacing={0} margin={1}>
          <Grid
            height={100}
            padding={1}
            margin={0.5}
            item
            xs={3.8}
            className="gridInformesLlamadas"
          >
            <div className={"titleSub" + " " + "gridComponentLlamada"}>
              Llamadas Recibidas
            </div>
            <hr></hr>
            <p className={"root"}>0</p>
          </Grid>
          <Grid
            height={100}
            padding={1}
            margin={0.5}
            item
            xs={3.8}
            className="gridInformesLlamadas"
          >
            <div className={"titleSub" + " " + "gridComponentLlamada"}>
              Llamadas Atendidas
            </div>
            <hr></hr>
            <p className={"root"}>0</p>
          </Grid>
          <Grid
            height={100}
            padding={1}
            margin={0.5}
            item
            xs={3.8}
            className="gridInformesLlamadas"
          >
            <div className={"titleSub" + " " + "gridComponentLlamada"}>
              Llamadas no Atendidas
            </div>
            <hr></hr>
            <p className={"root"}>0</p>
          </Grid>
          <Grid
            height={100}
            padding={1}
            margin={0.5}
            item
            xs={3.8}
            className="gridInformesLlamadas"
          >
            <div className={"titleSub" + " " + "gridComponentLlamada"}>
              Llamadas sin Respuesta
            </div>
            <hr></hr>
            <p className={"root"}>0</p>
          </Grid>
          <Grid
            height={100}
            padding={1}
            margin={0.5}
            item
            xs={3.8}
            className="gridInformesLlamadas"
          >
            <div className={"titleSub" + " " + "gridComponentLlamada"}>
              Llamadas Canceladas
            </div>
            <hr></hr>
            <p className={"root"}>0</p>
          </Grid>
          <Grid
            height={100}
            padding={1}
            margin={0.5}
            item
            xs={3.8}
            className="gridInformesLlamadas"
          >
            <div className={"titleSub" + " " + "gridComponentLlamada"}>
              Otras
            </div>
            <hr></hr>
            <p className={"root"}>0</p>
          </Grid>
        </Grid>
      </div>
      <div className={"mainContainer"}>
        <Styles>
          <Table columns={columnsTable1} data={data} />
        </Styles>
      </div>
      <div className={"mainContainer"}>
        <Styles>
          <Table columns={columnsTable2} data={data} />
        </Styles>
      </div>
      <div className={"mainContainer"}>
        <Styles>
          <Table columns={columnsTable3} data={data} />
        </Styles>
      </div>

      {/* <button className={menuButton} className="greenButton" onClick={{}}>Editar</button>
            <button className={menuButton} className="whiteButton" onClick={{}}>Cambiar Contraseña</button> */}
    </div>
  );
};

export default InformeLlamadas;
